import {createSlice} from '@reduxjs/toolkit'

export interface SearchSubmittedState {
  timestamp: string | null
}

const initialState: SearchSubmittedState = {
  timestamp: null
}

export const searchSubmittedSlice = createSlice({
  name: 'searchSubmitted',
  initialState,
  reducers: {
    submitSearch: (state: SearchSubmittedState): void => {
      state.timestamp = new Date().toISOString()
    }
  }
})

// selectors
export const selectSearchSubmitted = (state: any): Date | null => {
  try {
    return state?.searchSubmitted?.timestamp
      ? new Date(state.searchSubmitted.timestamp)
      : null
  } catch (e) {
    console.error('Error selecting search submitted:', e)
    return null
  }
}

// actions
export const {submitSearch} = searchSubmittedSlice.actions

// reducer
export default searchSubmittedSlice.reducer
